import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./motion/Reveal";

const PHOTO = "/santi-lidia-juntos.jpg";

export default function Accompaniment() {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const yImg = useTransform(scrollYProgress, [0, 1], [30, -30]);

    return (
        <section id="acompanamiento" className="relative py-20 sm:py-28 bg-alma-white overflow-hidden">
            <div className="max-w-[1200px] mx-auto px-6 sm:px-8" ref={ref}>
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                    <div className="relative">
                        <div className="absolute -inset-5 rounded-[2.5rem] bg-gradient-to-br from-alma-goldSoft/50 via-alma-sky/10 to-transparent blur-2xl" aria-hidden />
                        <div className="absolute -top-3 -left-3 h-24 w-24 rounded-full border border-alma-gold/40 animate-float-slow" aria-hidden />
                        <motion.div
                            style={{ y: yImg }}
                            className="relative rounded-[2rem] overflow-hidden border border-alma-mist shadow-2xl shadow-alma-ink/10"
                        >
                            <img src={PHOTO} alt="Lidia y Santi, Alquimia del Alma" className="w-full h-auto block" loading="lazy" />
                            <div className="absolute inset-0 bg-gradient-to-t from-alma-ink/20 to-transparent" aria-hidden />
                        </motion.div>
                    </div>

                    <div>
                        <Reveal>
                            <span className="text-xs tracking-[0.35em] uppercase text-alma-goldDeep font-medium">
                                Quién te acompaña
                            </span>
                            <h2 className="mt-5 font-serif text-4xl sm:text-5xl leading-[1.05] text-alma-ink">
                                Cerca, humana
                                <span className="italic text-alma-goldDeep"> y de verdad.</span>
                            </h2>
                            <p className="mt-6 font-sans text-lg text-alma-slate leading-relaxed">
                                Lidia cuida personalmente la comunidad: comparte reflexiones, aprendizajes y
                                experiencias, y acompaña a sus <span className="italic text-alma-ink">lucecitas</span> desde
                                la cercanía y el amor. Junto a ella, Santi aporta de vez en cuando su mirada sobre
                                la mente, las creencias y el crecimiento personal.
                            </p>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
